import axios from 'axios'
import store from '@/store'
import endpoints from 'api/endpoints'

// Defaults Settings for axios
axios.defaults.baseURL = `${process.env.API_URL}/api`
axios.defaults.headers.post['Content-Type'] = 'application/json'
if (localStorage.getItem('userToken')) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('userToken')}`
}

const originalRequest = {}

// Axios interceptors
axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    originalRequest.config = error.config
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        let data = {
            refreshToken: localStorage.getItem('refreshToken')
        }
        originalRequest._retry = true
        return axios({
            method: 'POST',
            url: endpoints.refresh,
            data: data,
            headers: {'Authorization': null}
        }).then((response) => {
            let value = {
                save: localStorage.getItem('userSave'),
                tokens: response.data
            }
            // save token and refresh token
            store.commit('TOKENS', value)
            if (value.save === 'false') {
                this.$store.commit('LOGOUT_TIMER')
            }
            originalRequest.config.headers.Authorization = `Bearer ${store.state.user.tokens.userToken}`

            // retry request
            return axios.request(originalRequest.config)
        }).catch((error) => {
            store.commit('LOGOUT')
            store.dispatch('globalAlertAction', {
                type: 'error',
                title: '401 Unauthorized, please re-login.',
                timeout: 8000,
                position: 'topRight'
            })
            return error
        })
    }
    return Promise.reject(error)
})

// End interceptors axios

// Promise for axios
function api(config) {
    return new Promise(function(resolve, reject) {
        return axios(config).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            let errorMessage = {message: ' Server Error'}
            let payload = {
                type: 'error',
                title: error.response ? error.response.status.toString() : errorMessage.message,
                message: error.response && error.response.data && error.response.data.exception ? error.response.data.exception.split('.')[0] : '',
                timeout: 10000,
                position: 'topRight'
            }

            if (error.status === 504) {
                payload.title = error.status + errorMessage.message
                store.dispatch('globalAlertAction', payload)
                return reject(errorMessage)
            } else if (!error.response) {
                store.dispatch('globalAlertAction', payload)
                return reject(error)
            } else {
                let errorData;
                if (error.response.data.status) {
                    errorData = error.response.data
                    store.dispatch('globalAlertAction', {
                        ...payload,
                        message: errorData.errors
                            ? errorData.errors.map(er => er.message).join(', ')
                            : errorData.exception.split('.')[0]
                    })
                } else {
                    errorData = error.response
                }
                return reject(errorData)
            }
        })
    })
}

export default function(method, endpoint, json, params, loader = true, responseType) {
    if (store.getters.authorization) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${store.state.user.tokens.userToken}`
    } else {
        axios.defaults.headers.common['Authorization'] = null
    }
    if (loader) store.commit('SET_LOADING', true)
    const apiConfig = {
        method: method,
        url: endpoint,
        data: json,
        params: params,
    }
    if (responseType) {
        apiConfig.responseType = responseType
    }
    return api({
        ...apiConfig
    }).then(response => {
        if (loader) store.commit('SET_LOADING', false)
        return response
    }).finally(() => { if (loader) store.commit('SET_LOADING', false) })
}



// WEBPACK FOOTER //
// ./src/api/index.js